import type { GatewayAssetOut, SimConnectivityState } from "kubb";
import type React from "react";
import SimConnectivityStateLabel from "../sim_cards/SimConnectivityStateLabel";

export default function GatewayListContent(props: {
  asset: GatewayAssetOut;
}): React.ReactElement {
  if (props.asset.asset_type !== "gateway") {
    throw new Error("Unsupported asset type");
  }

  return (
    <>
      {props.asset.sim_card_iccid && (
        <>
          Sim Iccid: {props.asset.sim_card_iccid}
          <SimConnectivityStateLabel
            state={props.asset.sim_connectivity_state as SimConnectivityState}
            size={"sm"}
            className={"px-1 py-1 ms-2"}
          />
        </>
      )}
    </>
  );
}
